import {
  CognitoUser,
  CognitoUserSession,
  CognitoIdToken,
  CognitoRefreshToken,
  CognitoAccessToken,
  CognitoUserPool,
} from 'amazon-cognito-identity-js';
import awsExports from '../aws-exports';
import amplifyInit from './amplifyInit';
import debug from './debug';

interface MobileSession {
  accessToken: {
    jwtToken: string;
    payload: {
      username: string;
    };
  };
  idToken: {
    jwtToken: string;
  };
  refreshToken: string;
}

const mobileLogin = (mobileSession: MobileSession, reload = true) => {
  debug('MobileLogin', mobileSession);

  const { cookieStorage } = amplifyInit();

  const localSession = new CognitoUserSession({
    IdToken: new CognitoIdToken({
      IdToken: mobileSession.idToken.jwtToken,
    }),
    RefreshToken: new CognitoRefreshToken({
      RefreshToken: mobileSession.refreshToken,
    }),
    AccessToken: new CognitoAccessToken({
      AccessToken: mobileSession.accessToken.jwtToken,
    }),
  });

  const localUser = new CognitoUser({
    Username: mobileSession.accessToken.payload.username,
    Pool: new CognitoUserPool({
      ClientId: awsExports.aws_user_pools_web_client_id,
      UserPoolId: awsExports.aws_user_pools_id,
    }),
    Storage: cookieStorage,
  });

  localUser.setSignInUserSession(localSession);

  debug('authData', localUser);

  if (reload) {
    window.location.reload();
  }
};

export default mobileLogin;
